// src/components/chat/ModalAvisoChat.js
import { useTranslation } from "react-i18next";

const ModalAvisoChat = ({ onClose }) => {
  const { t } = useTranslation();

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-[99999] flex items-center justify-center overflow-y-auto bg-slate-900/60 px-4 py-6 backdrop-blur-sm"
      onClick={handleOverlayClick}
    >
      <div className="w-full max-w-md max-h-[85vh] overflow-y-auto rounded-3xl border border-sky-100 bg-white p-6 sm:p-8 shadow-2xl text-slate-900">
        <h2 className="mb-5 text-center text-2xl font-bold tracking-tight text-[#247BA8]">
          {t("chat.modal_title")}
        </h2>
        <p className="text-base mb-4 font-semibold text-[#245580]">
          {t("chat.modal_body1")}
        </p>
        <p className="text-base mb-6 font-semibold text-[#245580]">
          {t("chat.modal_body2")}
        </p>
        <div className="text-right">
          <button
            onClick={onClose}
            className="inline-flex items-center justify-center rounded-xl border-2 border-green-600 bg-white px-6 py-3 font-semibold text-green-700 transition-colors duration-200 hover:bg-green-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
          >
            {t("chat.modal_button")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalAvisoChat;
